<template>
  <FilterBar
    ref="filters"
    :all-headers="allHeaders"
    :filter_types="allHeaders.filter(el => el.setFilter)"
    :loading="loading"
    :with_mode="false"
    @applyFilters="applyFilters"
    @applySearch="applySearch">
    <slot
      slot="append"
      name="append"/>
    <template #third_activator="{item}">
      <Statuses
        v-if="item.id === 'allowedVerificationStatuses' || item.id === 'verificationDecision'"
        :key="item.id"
        :data-qa="`toolbar-${item.id == 'allowedVerificationStatuses' ? 'verification-statuses' : 'decision'}`"
        :item="item"
        :item_key="item.id === 'allowedVerificationStatuses' ? 'verificationStatusId' : 'decisionTypeId'"
        item_title="title"
        :model.sync="item.value"
        :multiple="item.id === 'allowedVerificationStatuses'"
        :set-items="item.id === 'allowedVerificationStatuses' ? verif_info.verificationStatuses : verif_info.decisionTypes"
        :type="item.id"/>
      <DateRangeDialog
        v-else-if="item.id === 'verificationDecisionDateRange' || item.id === 'verificationStatusDateRange'"
        data-qa="toolbar-date-range"
        :search.sync="item.search"/>
    </template>
  </FilterBar>
</template>

<script>
import Statuses from 'components/common/blocks/Statuses.vue'
import FilterBar from 'components/common/blocks/FilterBar.vue'
import DateRangeDialog from 'components/common/dialogs/DateRangeDialog.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'suppliersToolbar',
  methods: {
    applySearch(search) {
      this.$emit('applySearch', search )
    },
    applyFilters(filters, mode, search) {
      this.$emit('applyFilters', filters, mode, search)
    },
  },
  computed: {
    ...mapGetters({
      verif_info: 'getCrmVerificationFillingInfo'
    }),
  },
  watch: {
    'filters.search': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!this.$refs?.filters) {
          return
        }
        if (!oldValue || newValue !== oldValue) {
          this.$refs.filters.searchValue = newValue
        }
      }
    }
  },
  props: {
    allHeaders: Array,
    filters: Object,
    loading: Boolean
  },
  components: {
    Statuses,
    FilterBar,
    DateRangeDialog,
  }
}
</script>
